import React from 'react'
import DashboardLayout from './DashboardLayout '
import GlobalHRSettings from './GlobalHRSettings';
import { Card, Col, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';


const Tools = () => {

  const DATA = [
    { title: "BambooHR", logo: "/toolsLogos/bamboohr.png", tooltip: "BambooHR is an online human resources software service for small and midsized businesses." },
    { title: "Zoho Recruit", logo: "/toolsLogos/Zoho Recruit.png", tooltip: "The all-in-one applicant tracking system for the modern recruiter. Share your job openings with the world! Publish job openings to your company's website and the most popular job boards to increase exposure and start sourcing top talent." },
    { title: "Greenhouse", logo: "/toolsLogos/greenhouse.png", tooltip: "Greenhouse is a hiring software company. We create the technology, know-how and support for your business' hiring needs." },
    { title: "Zoho People", logo: "/toolsLogos/zohopeople.png", tooltip: "Zoho People is an online HR management software which helps you automate all your HR processes efficiently." },
    { title: "Deel", logo: "/toolsLogos/deel.png", tooltip: "Deel helps thousands of companies expand globally with unmatched speed and flexibility. It’s global hiring, HR, and payroll in just one system." },
    { title: "Workday", logo: "/toolsLogos/Workday.png", tooltip: "Workday unites finance and HR on a single platform." },
    { title: "Hiretalent", logo: "/toolsLogos/hiretalent.png", tooltip: "AI-Powered Hiring Automation Platform For Global Hiring Empowering companies to source, select, and appoint talent." },
    { title: "Taleo", logo: "/toolsLogos/Taleo-Logo.png", tooltip: "Taleo Corporation is a provider of cloud-based talent management solutions, enabling businesses to recruit eligible candidates." },
    { title: "ADP", logo: "/toolsLogos/ADP.png", tooltip: "ADP is an American provider of human resources management software and services." },
    { title: "Indeed", logo: "/toolsLogos/Indeed.png", tooltip: "Indeed is an American worldwide employment-related search engine for job listings launched in November 2004." },
    { title: "Pingboard", logo: "/toolsLogos/Pingboard.png", tooltip: "Pingboard is real-time org chart software that makes it easy to build professional looking org charts." },
    { title: "Lanteria HR", logo: "/toolsLogos/Lanteria HR.png", tooltip: "Lanteria HR is a solution for managing HR processes, including time & attendance, recruiting, learning, compensation, and performance." },
  ];


  return (
    <DashboardLayout>
      <div className="main-content">

        <Row className="d-flex justify-content-between align-items-center mb-3">
          <Col xs="auto"><h2>Tools</h2></Col>
          <Col xs="auto"><GlobalHRSettings /></Col>
        </Row>
        <Col md={12} style={{ paddingLeft: '15px', paddingRight: '15px' }}>
          <Row>
            {DATA.map((item, index) => (
              <Col lg={3} sm={6} key={index}>
                <OverlayTrigger
                  placement="top"
                  overlay={
                    <Tooltip id={`tooltip-${index}`}>
                      <div style={{ maxWidth: '220px', whiteSpace: 'normal' }}>
                        {item.tooltip}
                      </div>
                    </Tooltip>
                  }
                >
                  <Card
                    className="card card-icon-bg card-icon-bg-primary o-hidden mb-4"
                    style={{ height: '100px', paddingLeft: '10px', cursor: 'pointer' }}
                  >
                    <Card.Body>
                      <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                        {item.logo && (
                          <img
                            src={item.logo}
                            alt={`${item.title} logo`}
                            style={{
                              height: '30px',
                              width: '30px',
                              objectFit: 'contain',
                              flexShrink: 0,
                            }}
                          />
                        )}
                        <span
                          className="text-primary text-capitalize"
                          style={{ fontSize: '1.1rem', fontWeight: 600, margin: 0 }}
                        >
                          {item.title}
                        </span>
                      </div>
                    </Card.Body>
                  </Card>
                </OverlayTrigger>

              </Col>
            ))}
          </Row>
        </Col>

      </div>
    </DashboardLayout>
  )
}

export default Tools;